<template>
  <el-container ref="container" class="h-full">
    <!--  头部 start  -->
    <el-header ref="header" class="p-0 header-con" height="42px">
      <div class="flex flex-row align-center justify-between">
        <!--   功能按钮组 start   -->
        <span class="page-name">
          <span>{{ pageData.pageName }}</span>
        </span>
        <!--   功能按钮组 end   -->
        <!--   列表页菜单 start   -->
        <slot name="table-option">
          <div class="flex flex-row align-center">
            <template v-for="option in pageData.tableOptions">
              <el-button
                v-if="option === 'init'"
                :key="option"
                class="option-btn"
                size="small"
                type="primary"
                @click="getinit()"
              >
                初始化用户
              </el-button>
              <el-button
                v-if="option === 'synchronization'"
                :key="option"
                class="option-btn"
                size="small"
                type="primary"
                @click="listSyncBtn()"
              >
                同步数据
              </el-button>
              <el-button
                v-if="option === 'add'"
                :key="option"
                class="option-btn"
                size="small"
                type="primary"
                @click="listCreateBtn"
              >新增
              </el-button>
              <el-button
                v-if="option === 'edit'"
                :key="option"
                class="option-btn"
                size="small"
                type="primary"
                @click="listUpdateBtn"
              >修改
              </el-button>
              <el-button
                v-if="option === 'details'"
                :key="option"
                class="option-btn"
                size="small"
                type="primary"
                @click="listDetailsBtn"
              >详情
              </el-button>
              <el-button
                v-if="option === 'delete'"
                :key="option"
                class="option-btn"
                size="small"
                type="danger"
                @click="listDeleteBtn"
              >删除
              </el-button>
              <el-button
                v-if="option === 'filter'"
                :key="option"
                icon="filter-icon"
                plain
                size="small"
                type="primary"
                @click="showSearchArea"
              >
                高级筛选
              </el-button>
            </template>
          </div>
        </slot>
        <!--   列表页菜单 end   -->
      </div>
    </el-header>
    <!--  头部 end  -->
    <el-main ref="main" class="p-0">
      <!-- 查询区 start -->
      <div ref="searchContainer" class="flex flex-col searcher-con">
        <transition name="fade-transform">
          <div v-show="showSearch" class="high-search-area">
            <el-form
              v-model="searcher"
              :disabled="false"
              :inline="true"
            >
              <el-row v-for="row in pageData.searchItems" :key="row.rowIndex">
                <el-col v-for="(col,index) in row.items" :key="index" :span="col.span">
                  <form-select-item
                    v-if="col.type==='select'"
                    :ref="`input_${col.code}`"
                    v-model="searcher[col.code]"
                    :code="col.code"
                    :name="col.name"
                    v-bind="col.config"
                  />
                  <form-group-search-item
                    v-else-if="col.type==='group'"
                    :ref="`input_${col.code}`"
                    v-model="searcher[col.code]"
                    :code="col.code"
                    :name="col.name"
                    v-bind="col.config"
                  />
                  <form-date-item
                    v-else-if="col.type==='date'"
                    :ref="`input_${col.code}`"
                    v-model="searcher[col.code]"
                    :code="col.code"
                    :name="col.name"
                    v-bind="col.config"
                  />
                  <form-popup-item
                    v-else-if="col.type==='popup'"
                    :ref="`input_${col.code}`"
                    v-model="searcher[col.code]"
                    :code="col.code"
                    :name="col.name"
                    v-bind="col.config"
                    v-on="col.handleEvent"
                  />
                  <form-time-item
                    v-else-if="col.type==='time'"
                    :ref="`input_${col.code}`"
                    v-model="searcher[col.code]"
                    :code="col.code"
                    :name="col.name"
                    v-bind="col.config"
                  />
                  <form-datetime-item
                    v-else-if="col.type==='datetime'"
                    :ref="`input_${col.code}`"
                    v-model="searcher[col.code]"
                    :code="col.code"
                    :name="col.name"
                    v-bind="col.config"
                  />
                  <form-text-item
                    v-else
                    :ref="`input_${col.code}`"
                    v-model="searcher[col.code]"
                    :code="col.code"
                    :name="col.name"
                    v-bind="col.config"
                  />
                </el-col>
              </el-row>
              <el-form-item>
                <div class="w-full flex flex-row justify-end">
                  <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
                  <el-button size="small" type="primary" @click="resetBtn">重置</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </transition>
      </div>
      <!-- 查询区 end -->
      <!-- 数据表 -->
      <el-table
        ref="table"
        v-loading="loading"
        :border="true"
        :data="tableData"
        :fit="true"
        :highlight-current-row="true"
        :max-height="tableMaxHeight"
        :select-on-indeterminate="true"
        :stripe="true"
        cell-class-name="ik-list-table-body-cell"
        element-loading-text="加载中..."
        header-cell-class-name="ik-list-table-header-cell"
        header-row-class-name="ik-list-table-header-row"
        row-class-name="ik-list-table-body-row"
        @row-click="rowClick"
      >
        <template v-for="(column,index) in pageData.columns">
          <table-image-item
            v-if="column.type==='oss'"
            :key="index"
            :code="column.code"
            :name="column.name"
            v-bind="column.config"
          />
          <table-file-item
            v-else-if="column.type==='file'"
            :key="index"
            :code="column.code"
            :name="column.name"
            v-bind="column.config"
          />
          <table-number-item
            v-else-if="column.type==='number'"
            :key="index"
            :code="column.code"
            :name="column.name"
            v-bind="column.config"
          />
          <table-datetime-item
            v-else-if="column.type==='datetime'"
            :key="index"
            :code="column.code"
            :name="column.name"
            v-bind="column.config"
          />
          <table-group-item
            v-else-if="column.type==='group'"
            :key="index"
            :code="column.code"
            :data-down="loading"
            :name="column.name"
            v-bind="column.config"
          />
          <table-group-item
            v-else-if="column.type==='video'"
            :key="index"
            :code="column.code"
            :name="column.name"
            key-field="key"
            v-bind="column.config"
            value-field="value"
          />
          <table-time-item
            v-else-if="column.type==='time'"
            :key="index"
            :code="column.code"
            :name="column.name"
            v-bind="column.config"
          />
          <table-select-item
            v-else-if="column.type==='select'"
            :key="index"
            :code="column.code"
            :name="column.name"
            key-field="key"
            v-bind="column.config"
            value-field="value"
          />
          <table-editor-item
            v-else-if="column.type==='editor'"
            :key="index"
            :code="column.code"
            :name="column.name"
            v-bind="column.config"
            @showContent="contentShow"
          />
          <table-text-item
            v-else
            :key="index"
            :code="column.code"
            :name="column.name"
            v-bind="column.config"
          />
        </template>
      </el-table>
    </el-main>
    <!-- 分页组件 -->
    <el-footer ref="pagination" class="p-0" height="auto">
      <el-pagination
        :current-page.sync="pagination.pageNo"
        :page-size.sync="pagination.pageSize"
        :total="pagination.totalCount"
        background
        class="w-full"
        layout="total,->, prev, pager, next,sizes,jumper"
        @current-change="pageChange"
      />
    </el-footer>
    <!-- 添加弹窗 -->
    <el-dialog
      :title="`查看内容`"
      :visible.sync="dialogVisible"
      top="5vh"
      width="80%"
    >
      <div style="height: 600px; overflow: auto;">
        <show-content
          v-if="dialogVisible"
          :field="currentField"
          :row="currentRow"
          :row-code="currentRowCode"
        />
      </div>
    </el-dialog>
  </el-container>

</template>

<script>
import { findPage, remove, getInit, postData } from '@/api/ik/data/dataApi'
import showContent from './tableComp/tableItems/ShowContent.vue'

export default {
  components: { showContent },
  data() {
    return {
      loading: false,
      // 查询器是否激活
      searcherActive: "0",
      searcher: {},
      // 列表页数据
      tableData: [],
      // 当前选中行
      activeRow: {},
      dialogVisible: false,
      currentRowCode: '',
      currentField: '',
      currentRow: {},
      // 分页器
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0
      },
      // 当前数据id
      id: 0,
      // 是否显示高级搜索
      showSearch: false,
      tableMaxHeight: 800
    }
  },
  inject: ["pageData"],
  watch: {
    showSearch() {
      this.$nextTick(this.calculateTableHeight)
    }
  },
  activated() {
    this.find()
  },
  mounted() {
    this.calculateTableHeight()
    window.addEventListener('resize', this.calculateTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight)
  },
  methods: {
    calculateTableHeight() {
      if (!this.$refs.container) return
      console.log(this.$refs.header)

      // 1. 获取关键区域的高度
      const headerHeight = this.$refs.header.$el.offsetHeight || 42
      const searchHeight = this.showSearch
        ? (this.$refs.searchContainer?.offsetHeight || 0)
        : 0
      const paginationHeight = this.$refs.pagination?.$el.offsetHeight || 0

      // 2. 计算容器剩余高度
      const containerHeight = this.$refs.container.$el.clientHeight
      const padding = 44 // 安全间距（可选）
      const maxHeight = containerHeight - headerHeight - searchHeight - paginationHeight - padding
      // 3. 设置表格高度（最小200px防止异常）
      this.tableMaxHeight = Math.max(maxHeight, 200)
    },
    /**
     * 显示搜索区域
     */
    showSearchArea() {
      this.showSearch = !this.showSearch
    },
    /**
     * 新增按钮
     */
    listCreateBtn() {
      this.pageData.viewMode = "info"
      this.pageData.mode = "add"
    },
    getinit() {
      if (this.activeRow.id === undefined) {
        this.$message.warning('请选择需要初始化的行!')
      } else {
        getInit(this.pageData.bgPath, this.activeRow.code).then(res => {
          this.$message.success('初始化成功')
        })
      }
    },
    /**
     * 编辑按钮
     */
    listUpdateBtn() {
      // 是否选择行
      if (this.activeRow.id === undefined) {
        this.$message.warning('请选择需要编辑的行!')
      } else {
        console.log(this.pageData)
        this.pageData.viewMode = "info"
        this.pageData.mode = "edit"
        this.pageData.activeId = this.activeRow.id
      }
    },
    /**
     * 列表页详情按钮点击
     */
    listDetailsBtn() {
      // 是否选择行
      if (this.activeRow.id === undefined) {
        this.$message.warning('请选择需要编辑的行!')
      } else {
        // 修改为详情模式
        this.pageData.viewMode = "info"
        this.pageData.mode = "details"
        this.pageData.activeId = this.activeRow.id
      }
    },
    /**
     * 列表页删除按钮点击
     */
    listDeleteBtn() {
      // 是否选择行
      if (this.activeRow.id === undefined) {
        this.$message.warning('请选择需要删除的行!')
      } else {
        // 问询是否删除
        this.$confirm('删除ID为' + this.activeRow.id + '的数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delete(this.activeRow.id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    /**
     * 更新表单
     * @param key
     * @param value
     */
    updateFormData(key, value) {
      this.$set(this.searcher, key, value)
    },
    /**
     * 查询
     */
    searchBtn() {
      this.find()
    },
    /**
     * 重置
     */
    resetBtn() {
      this.searcher = {}
      this.find()
    },
    /**
     * 分页器数据变更
     * @param pageNo
     * @param pageSize
     */
    pageChange(pageNo, pageSize) {
      // 修改分页数据
      this.pagination.pageNo = pageNo
      // this.pagination.pageSize = pageSize
      // 刷新数据
      this.find()
    },
    /**
     * 行点击事件
     * @param row
     */
    rowClick(row) {
      this.activeRow = row
    },
    /**
     * 删除数据
     * @param id
     */
    delete(id) {
      this.loading = true
      remove(this.pageData.bgPath, id).then(() => {
        this.$message.warning('数据已删除!')
        this.find()
      })
        .finally(() => {
          this.loading = false
        })
    },
    /**
     * 查询数据
     */
    find() {
      this.loading = true
      if (this.pageData.useStore) {
        this.searcher["storeId"] = this.$store.getters['user/getStoreId']
        this.searcher["storeCode"] = this.$store.getters['user/getStoreCode']
      }
      this.tableData = []
      console.log(this.pageData.bgPath, 'this.pageData.bgPath')

      // 获取树组件数据
      findPage(this.pageData.bgPath, this.searcher, this.pagination.pageSize, this.pagination.pageNo)
        .then(response => {
          // 设置表格数据
          this.tableData = response.data.list
          // 设置分页器
          this.pagination.totalCount = response.data.totalCount
        })
        .finally(() => {
          this.loading = false
        })
    },
    /**
     * 显示内容
     * @param row
     * @param code
     */
    contentShow(row, code) {
      this.currentRowCode = row["contentInfoCode"]
      this.currentField = code
      this.dialogVisible = true
      this.currentRow = {
        ...row
      }
    },
    // 同步数据词典
    listSyncBtn() {
      const $this = this
      $this.listLoading = true
      console.log(this.pageData.bgPath)

      postData(this.pageData.bgPath + "/do/syncdic", { "storeCode": this.$store.getters['user/getUserCode'] }).then(res => {
        $this.listLoading = false
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已同步!'
        })
      }).catch(() => {
        $this.listLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

@import "~@/styles/listinfo";

::v-deep .ik-list-table {
  overflow-x: scroll;
}

::v-deep .el-input__suffix {
  cursor: pointer;
}

::v-deep .el-button {
  .filter-icon {
    width: 14px;
    height: 14px;
    display: inline-block;
    background-image: url("../../../assets/list/filter.png");
  }
}

// 头部容器
.header-con {
  margin-bottom: 16px;

  .page-name {
    font-family: PingFang SC, PingFang SC, serif;
    font-weight: bolder;
    font-size: 20px;
    color: #1D2129;
    line-height: 28px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

.searcher-con {

  .easy-search-area {
    margin-bottom: 8px;
  }

  .high-search-area {
    background-color: #F5F7F8;
    padding: 12px;
    margin-bottom: 20px;
  }
}

::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
}

::v-deep .el-pagination {
  .el-input__inner {
    height: 28px !important;
    line-height: 28px !important;
  }
}

.data-directory-tabs-info {
  height: calc(100% - 60px);
}

.data-directory-tabs-info .el-tabs__content {
  height: calc(100% - 53px);
  overflow: auto;
  min-height: 350px;
}

// 表格
::v-deep .el-table {
  .el-table__fixed {
    height: auto !important;
    bottom: 17px;
  }

  /* 表格样式 */

  .ik-list-table-header-row {
    background-color: #F2F3F5;
    border-color: #E5E6EB;

    .ik-list-table-header-cell {
      height: 46px;
      background-color: #F2F3F5;
      color: #1D2129;
      border-color: #E5E6EB;
    }

    th {
      padding: 0;
    }
  }

  .ik-list-table-header-row .ik-list-table-header-cell > .cell {
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ik-list-table-body-row {
    padding: 0;
    height: 40px;
    line-height: 40px;
  }

  .ik-list-table-body-row-hide {
    display: none;
  }

  .ik-list-table-body-cell {
    padding: 0;
  }
}
</style>
